import { jsx, jsxs } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
const EmptyState = ({
  title,
  description,
  icon,
  action,
  sx = {},
  isForGadget = false,
  iconCircle = false,
  iconCircleSize = 64,
  bordered = false
}) => {
  const { gray } = useColors();
  const wrappedIcon = icon && iconCircle ? /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        width: iconCircleSize,
        height: iconCircleSize,
        borderRadius: "50%",
        bgcolor: gray[50],
        color: gray[400],
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      children: icon
    }
  ) : icon;
  const containerSx = {
    p: 4,
    minHeight: bordered || isForGadget ? void 0 : "30vh",
    flex: bordered || isForGadget ? 1 : void 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    ...isForGadget && !bordered && {
      boxShadow: "none",
      bgcolor: "transparent",
      height: "100%"
    },
    ...bordered && {
      boxShadow: "none",
      bgcolor: "background.paper",
      border: `1px solid ${gray[100]}`,
      borderRadius: 1,
      height: "100%"
    },
    ...sx
  };
  return /* @__PURE__ */ jsxs(Paper, { elevation: isForGadget || bordered ? 0 : 1, sx: containerSx, children: [
    wrappedIcon && /* @__PURE__ */ jsx(Box, { sx: { mb: 2, color: "text.secondary" }, children: wrappedIcon }),
    title && /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: 600, gutterBottom: true, children: title }),
    description && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "text.secondary", sx: { mb: 2 }, children: description }),
    action && /* @__PURE__ */ jsx(Box, { sx: { mt: 2 }, children: action })
  ] });
};
export {
  EmptyState
};
